<template>
  <div v-on:click="click" class="box" :class="selected ? 'box-selected' : 'box-not-selected'">
    <img
      v-if="selected"
      class="icon"
      :src="loadIconArrow"
      alt="clear"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        selected: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        loadIconArrow() {
            return require('@/assets/img/check.svg');
        },
    },
    methods: {
        click() {
            this.$emit('tick', !this.selected);
        }
    }
});
</script>

<style scoped>
.box{
    height: 18px;
    width: 18px;
    border-radius: 1px;
    cursor: pointer;
}
.box-selected{
    background-color: var(--radio);
    border: 1px solid var(--radio);
}
.box-not-selected{
    border: 1px solid var(--medium-dark-grey);
}
.icon{
    width: 16px;
    height: 16px;
    margin: 0;
}
</style>
